module.exports = __webpack_public_path__ + "static/img/DO.3fe1405c.svg";